import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Separate numbers and letters so that numbers can be <sub>2</sub>
 * @param formula a string H2O
 * @returns ['H', '2', '0']
 */
function parseFormula(formula) {
    return [...(formula !== null && formula !== void 0 ? formula : '')].reduce((acc, current) => {
        const last = acc.pop();
        const letter = current === '+' ? '⁺' : current === '-' ? '⁻' : current;
        const isNumber = letter.match(/[0-9]/);
        const lastIsNumber = last === null || last === void 0 ? void 0 : last.match(/[0-9]/);
        if (isNumber) {
            if (lastIsNumber) {
                return [...acc, `${last !== null && last !== void 0 ? last : ''}${letter}`];
            }
            return [...acc, last, letter].filter((v) => !!v);
        }
        if (lastIsNumber) {
            return [...acc, last, letter].filter((v) => !!v);
        }
        return [...acc, `${last !== null && last !== void 0 ? last : ''}${letter}`];
    }, []);
}
export const ChemicalFormula = ({ node }) => {
    const parts = parseFormula(node.value);
    return (_jsx("span", { className: "text-inherit", "aria-roledescription": "Chemical Formula", children: parts.map((letter, index) => {
            if (letter.match(/[0-9]/))
                return _jsx("sub", { children: letter }, index);
            return _jsx("span", { children: letter }, index);
        }) }));
};
const CHEM_RENDERERS = {
    chemicalFormula: ChemicalFormula,
};
export default CHEM_RENDERERS;
